import { Box } from "@chakra-ui/react";
import PersonalInformationCard from "./PersonalInformationCard";
import ChangePasswordCard from "./ChangePasswordCard";

export default function CustomerProfileDetails() {
  return (
    <Box mx="0">
      <PersonalInformationCard />
      <ChangePasswordCard />
    </Box>
  );
}
